'use strict';
var createModalWindow = function() {
    var modal = document.createElement('div');
    modal.className = 'modal';
    var overlay = document.createElement('div');
    overlay.className = 'modal__overlay';
    var dialog = document.createElement('div');
    dialog.className = 'modal__dialog';
    var closeBtn = document.createElement('button');
    closeBtn.className = 'modal__close';
    closeBtn.type = 'button';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.textContent = "\xd7";
    var title = document.createElement('h3');
    title.className = 'modal__title';
    title.textContent = "\u0420\u0435\u0454\u0441\u0442\u0440\u0430\u0446\u0456\u044F";
    var modalForm = document.createElement('form');
    modalForm.className = 'modal__form';
    var nameInput = document.createElement('input');
    nameInput.className = 'modal__input';
    nameInput.type = 'text';
    nameInput.name = 'name';
    nameInput.placeholder = "\u0406\u043C'\u044F";
    nameInput.required = true;
    var emailInput = document.createElement('input');
    emailInput.className = 'modal__input';
    emailInput.type = 'email';
    emailInput.name = 'email';
    emailInput.placeholder = 'Email';
    emailInput.required = true;
    var submitBtn = document.createElement('button');
    submitBtn.className = 'button';
    submitBtn.type = 'submit';
    submitBtn.textContent = "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u0442\u0438";
    modalForm.appendChild(nameInput);
    modalForm.appendChild(emailInput);
    modalForm.appendChild(submitBtn);
    dialog.appendChild(closeBtn);
    dialog.appendChild(title);
    dialog.appendChild(modalForm);
    modal.appendChild(overlay);
    modal.appendChild(dialog);
    document.body.appendChild(modal);
    var open = function() {
        modal.classList.add('modal--open');
        document.body.classList.add('no-scroll');
    };
    var close = function() {
        modal.classList.remove('modal--open');
        setTimeout(function() {
            document.body.classList.remove('no-scroll');
        }, 500);
    };
    overlay.addEventListener('click', close);
    closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') close();
    });
    modalForm.addEventListener('submit', function(e) {
        e.preventDefault();
        nameInput.value = '';
        emailInput.value = '';
        close();
    });
    return {
        open: open,
        close: close
    };
};
var setupModalForButtons = function() {
    var buttons = document.querySelectorAll('.events__button, .header__button');
    if (!buttons.length) return;
    var modal = createModalWindow();
    buttons.forEach(function(btn) {
        btn.addEventListener('click', function(e) {
            e.preventDefault();
            modal.open();
        });
    });
};
document.addEventListener('DOMContentLoaded', setupModalForButtons);

//# sourceMappingURL=Museum_2.70a44018.js.map
